/**
 * The states Stable will take mail in.
 *
 * A vendor's coverage, not a fact about the jurisdictions themselves, so the content has no row
 * for it and this stays a list. It belongs on the backend beside the rest of the Stable
 * integration; it is here because that is where it was.
 *
 * Written as the content spells a jurisdiction, which is what an entity stores.
 */
export const STABLE_SUPPORT_STATE_JURISDICTION: string[] = [
  'ADM1_US-GA',
  'ADM1_US-TX',
  'ADM1_US-MA',
  'ADM1_US-NC',
  'ADM1_US-WY',
  'ADM1_US-NJ',
  'ADM1_US-DE',
  'ADM1_US-NV',
  'ADM1_US-NY',
  'ADM1_US-IL',
  'ADM1_US-FL',
  'ADM1_US-PA',
  'ADM1_US-AZ',
  'ADM1_US-WA',
  'ADM1_US-CA',
];
